import { joinParts } from '../utils'

export const location = {
  data: (idOrCodeurl: string) => joinParts('locations', idOrCodeurl),
  bulk: (idsOrCodeUrls: string[]) => `/locations?ids=${idsOrCodeUrls.join(',')}`,
}
